import { render, staticRenderFns } from "./CustomHomeSlider.vue?vue&type=template&id=38ac63da"
import script from "./CustomHomeSlider.vue?vue&type=script&lang=js"
export * from "./CustomHomeSlider.vue?vue&type=script&lang=js"
import style0 from "./CustomHomeSlider.vue?vue&type=style&index=0&id=38ac63da&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports